module.exports = __webpack_public_path__ + "img/emojipedia_wechat_ios_802_toasted.png";